/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSubset } from '../../factoriesAny.js';
export var subsetDependencies = {
  matrixDependencies,
  typedDependencies,
  createSubset
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSubset.generated.js
// module id = 69
// module chunks = 2